import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ProcessHubService } from './aplication/api/Services/Process.hub.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private primengConfig: PrimeNGConfig, private translateService: TranslateService, private _processHubService: ProcessHubService) {}

  ngOnInit() {
    this.primengConfig.ripple = true;
    if(localStorage.getItem('authTokenLicitaAdmin')) {
      this._processHubService.initializeConnection();
    }

    this.translateService.setDefaultLang('pt-br');
    this.translateService.use('pt-br').subscribe(() => {
      // Após carregar as traduções, aplica-as ao PrimeNG
      this.translateService.get('primeng').subscribe(res => {
        this.primengConfig.setTranslation(res);
      });
    });
  }
  ngOnDestroy() {
    // Fecha a conexão com o WebSocket ao destruir o componente
    this._processHubService.stopConnection();
  }
}
